import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AppShell from './AppShell.jsx';
import './index.css';

const root = document.getElementById('root');

const app = (
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);

// Если в #root уже есть пререндеренный HTML — «оживляем» его (hydrate), без мигания.
// Иначе (dev / отсутствие пререндера) — обычный клиентский рендер.
if (root.hasChildNodes()) {
  hydrateRoot(root, app, {
    onRecoverableError: (err) => console.error('[hydration]', err),
  });
} else {
  createRoot(root).render(app);
}
